<div class="loadding-container">
  <mat-card>
    <img src="../../../assets/64-64-asli.png" alt="">
    <div class="text">لطفا صبر کنید ...</div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </mat-card>
</div>
